import { motion } from "framer-motion";
import XLogo from "./XLogo";

const letters = "TEAM X".split("");

export default function LoadingScreen() {
  return (
    <motion.div
      data-testid="loading-screen"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#050507]"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
    >
      <motion.div
        initial={{ scale: 0.6, opacity: 0, rotate: -12 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <XLogo size={84} />
      </motion.div>
      <div className="mt-6 flex overflow-hidden">
        {letters.map((l, i) => (
          <motion.span
            key={i}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ delay: 0.35 + i * 0.07, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className={`font-display text-4xl font-black uppercase tracking-[0.3em] ${
              l === "X" ? "text-brand" : "text-white"
            }`}
          >
            {l === " " ? "\u00A0" : l}
          </motion.span>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9 }}
        className="mt-3 font-mono text-[10px] uppercase tracking-[0.35em] text-neutral-500"
      >
        Global Investment Education
      </motion.p>
      <div className="mt-8 h-px w-48 overflow-hidden bg-white/10">
        <motion.div
          className="h-full bg-brand"
          initial={{ x: "-100%" }}
          animate={{ x: "0%" }}
          transition={{ duration: 1.7, ease: "easeInOut", delay: 0.2 }}
        />
      </div>
    </motion.div>
  );
}
